import { render, staticRenderFns } from "./qualityClassification.vue?vue&type=template&id=0d4ee21d&scoped=true&"
import script from "./qualityClassification.vue?vue&type=script&lang=js&"
export * from "./qualityClassification.vue?vue&type=script&lang=js&"
import style0 from "./qualityClassification.vue?vue&type=style&index=0&id=0d4ee21d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ee21d",
  null
  
)

export default component.exports